import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Spin, Pagination } from 'antd';
import NoData from 'components/NoData';
import { permissionService } from 'shared/services';
import { addParamPageURL, getParamURL } from 'shared/utils/UrlUtil';
import allBillerRoute from 'modules/AllBillers/route';

import text from '../FormDetail.page.translation';
const { checkPermission } = permissionService;
export default class BillerOfForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNow: 1,
      totalItem: 0,
    };
  }

  componentDidMount() {
    this._getList(getParamURL('page'));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formId !== this.props.formId) {
      this._getList(getParamURL('page'));
    }
  }

  _getList = page => {
    const { getBillerOfForm, formId } = this.props;

    const pageValue = parseInt(page, 10) || 1;

    const formsParams = {
      page_num: pageValue,
      page_size: 6,
    };
    this.setState({ pageNow: pageValue }, () => {
      getBillerOfForm(
        formId,
        formsParams,
        this._successGetList,
        this._errorGetList,
      );
    });
  };

  _successGetList = pagination => {
    const totalItem =
      _.get(pagination, 'page_size', 0) * _.get(pagination, 'page_count', 0);
    this.setState({ totalItem });
  };

  _errorGetList = () => {
    this.setState({ totalItem: 0 });
  };

  _handleChangePage = page => {
    const { history } = this.props;
    addParamPageURL(history.location.pathname, page, history);
    this._getList(page);
    this.setState({
      pageNow: parseInt(page, 10),
    });
  };

  _getStatus = status => {
    if (status === 1) {
      return 'Inactive';
    }
    if (status === 2) {
      return 'Active';
    }
    return 'Hidden';
  };

  _goToBillerDetail = id => () => {
    if (checkPermission('Biller:read', true))
      this.props.history.push(allBillerRoute.BILLERS_DETAIL.replace(':id', id));
  };

  _renderBillerPart = item => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="card-item top">
        <div className="item-title">
          <div className="title-btn" onClick={this._goToBillerDetail(item.id)}>
            <span className="title-text">{_.get(item, 'name')}</span>
          </div>
          <span>{_.get(item, 'public_id')}</span>
        </div>
        <div className="status-wrapper">
          <span>{formatMessage(text.billerOfForm.pgStatus)}</span>
          <span
            className={this._getStatus(
              _.get(item, 'pground_status'),
            ).toLowerCase()}
          >
            {this._getStatus(_.get(item, 'pground_status'))}
          </span>
        </div>
        <div className="status-wrapper">
          <span>{formatMessage(text.billerOfForm.skwStatus)}</span>
          <span
            className={this._getStatus(
              _.get(item, 'skyw_status'),
            ).toLowerCase()}
          >
            {this._getStatus(_.get(item, 'skyw_status'))}
          </span>
        </div>
      </div>
    );
  };

  _renderServicePart = item => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="card-item">
        <div className="item-title">
          <span className="service-text">{_.get(item, 'service.name')}</span>
        </div>
        <div className="status-wrapper">
          <span>{formatMessage(text.billerOfForm.serviceStatus)}</span>
          <span className={_.get(item, 'service.status').toLowerCase()}>
            {_.get(item, 'service.status')}
          </span>
        </div>
      </div>
    );
  };

  _renderItem = item => (
    <div className="card-item-list" key={`item_${item.id}`}>
      {this._renderBillerPart(item)}
      {this._renderServicePart(item)}
    </div>
  );

  render() {
    const {
      intl: { formatMessage },
      billerOfForm,
    } = this.props;

    return (
      <div className="white-box-wrapper" style={{ paddingBottom: '0px' }}>
        <div className="connected-form">
          <span className="title">
            {formatMessage(text.billerOfForm.title)}
          </span>
        </div>
        <Spin spinning={this.props.loading}>
          {billerOfForm.length ? (
            <div className="list-connected-wrapper">
              {_.chunk(billerOfForm, 2).map(chunk => (
                <div key={chunk[0].form_id} className="row-list">
                  {chunk.map(item => this._renderItem(item))}
                  {chunk.length !== 2 && <div className="placeholder-item" />}
                </div>
              ))}
              <div className="pagination">
                <Pagination
                  total={this.state.totalItem}
                  pageSize={6}
                  current={this.state.pageNow}
                  onChange={this._handleChangePage}
                />
              </div>
            </div>
          ) : (
            <NoData />
          )}
        </Spin>
      </div>
    );
  }
}

BillerOfForm.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object,
  billerOfForm: PropTypes.array,
  loading: PropTypes.bool,
  getBillerOfForm: PropTypes.func,
  formId: PropTypes.string,
};
